// // src/store/visualizationTypeSlice.js
// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   currentType: null,        // Current selected visualization type
//   previousType: null,       // Previous visualization type (for back navigation)
//   isInitialized: false,     // Track if visualization type has been set
//   useTemproBarChart: false, // ✅ New: track checkbox state for Bar Chart
// };

// const visualizationTypeSlice = createSlice({
//   name: "visualizationType",
//   initialState,
//   reducers: {
//     setVisualizationType: (state, action) => {
//       const { type } = action.payload;
      
//       // Store previous type before updating
//       if (state.currentType) {
//         state.previousType = state.currentType;
//       }
      
//       state.currentType = type;
//       state.isInitialized = true;
//     },
    
//     clearVisualizationType: (state) => {
//       state.currentType = null;
//       state.previousType = null;
//       state.isInitialized = false;
//       state.useTemproBarChart = false;// ✅ reset checkbox when clearing
//     },
    
//     resetVisualizationType: (state) => {
//       return initialState;
//     },
    
//     // For back navigation - restore previous type
//     restorePreviousType: (state) => {
//       if (state.previousType) {
//         state.currentType = state.previousType;
//         state.previousType = null;
//       }
//     },
//     setUseTemproBarChart: (state, action) => {
//       state.useTemproBarChart = action.payload;
//     },
//   },
// });

// export const { 
//   setVisualizationType, 
//   clearVisualizationType, 
//   resetVisualizationType,
//   restorePreviousType,
//   setUseTemproBarChart,
// } = visualizationTypeSlice.actions;

// export default visualizationTypeSlice.reducer;
// src/store/visualizationTypeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentType: null,        // Current selected visualization type
  previousType: null,       // Previous visualization type (for back navigation)
  isInitialized: false,     // Track if visualization type has been set
  useTemproBarChart: false, // Track checkbox state for Bar Chart
  useUlgMap: false,         // Track checkbox state for ULG Map
};

const visualizationTypeSlice = createSlice({
  name: "visualizationType",
  initialState,
  reducers: {
    setVisualizationType: (state, action) => {
      const { type } = action.payload;
      
      // Store previous type before updating
      if (state.currentType) {
        state.previousType = state.currentType;
      }
      
      state.currentType = type;
      state.isInitialized = true;
    },
    
    clearVisualizationType: (state) => {
      state.currentType = null;
      state.previousType = null;
      state.isInitialized = false;
      state.useTemproBarChart = false; // Reset checkbox when clearing
      state.useUlgMap = false;         // Reset ULG Map checkbox when clearing
    },
    
    resetVisualizationType: (state) => {
      return initialState;
    },
    
    // For back navigation - restore previous type
    restorePreviousType: (state) => {
      if (state.previousType) {
        state.currentType = state.previousType;
        state.previousType = null;
      }
    },
    
    setUseTemproBarChart: (state, action) => {
      state.useTemproBarChart = action.payload;
    },
    
    setUseUlgMap: (state, action) => {
      state.useUlgMap = action.payload;
    },
  },
});

export const { 
  setVisualizationType, 
  clearVisualizationType, 
  resetVisualizationType,
  restorePreviousType,
  setUseTemproBarChart,
  setUseUlgMap,
} = visualizationTypeSlice.actions;

export default visualizationTypeSlice.reducer;